/* eslint-disable max-len */

export const Learnsets: {[k: string]: LearnsetData} = {
	articunogalar: {
		learnset: {
			agility: ["8M", "8L20"],
			airslash: ["8M"],
			allyswitch: ["8M"],
			ancientpower: ["8L25"],
			bravebird: ["8M"],
			calmmind: ["8M"],
			confusion: ["8L5"],
			dreameater: ["8L50"],
			dualwingbeat: ["8T"],
			endure: ["8M"],
			expandingforce: ["8T"],
			facade: ["8M"],
			fly: ["8M"],
			freezingglare: ["8L45", "8S0", "8S1"],
			futuresight: ["8M", "8L65"],
			gigaimpact: ["8M"],
			guardswap: ["8M"],
			gust: ["8L1"],
			hurricane: ["8M", "8L55", "8S0", "8S1"],
			hyperbeam: ["8M"],
			hypervoice: ["8M"],
			hypnosis: ["8L15"],
			imprison: ["8M"],
			lightscreen: ["8M"],
			mindreader: ["8L60"],
			powerswap: ["8M"],
			protect: ["8M"],
			psychic: ["8M"],
			psychocut: ["8M", "8L35", "8S0", "8S1"],
			psychoshift: ["8L1", "8S0", "8S1"],
			psyshock: ["8M"],
			recover: ["8L40"],
			reflect: ["8M", "8L10"],
			rest: ["8M"],
			round: ["8M"],
			scaryface: ["8M"],
			shadowball: ["8M"],
			skillswap: ["8M"],
			sleeptalk: ["8M"],
			snore: ["8M"],
			steelwing: ["8M"],
			storedpower: ["8M"],
			substitute: ["8M"],
			swift: ["8M"],
			tailwind: ["8L30"],
			trickroom: ["8M", "8L70"],
			uturn: ["8M"],
		},
		eventData: [
			{generation: 8, level: 70, moves: ["freezingglare", "hurricane", "psychocut", "psychoshift"]},
			{generation: 8, level: 70, shiny: true, moves: ["freezingglare", "hurricane", "psychocut", "psychoshift"], pokeball: "cherishball"},
		],
		eventOnly: true,
	},
	zapdosgalar: {
		learnset: {
			acrobatics: ["8M"],
			agility: ["8M", "8L20"],
			ancientpower: ["8L25"],
			assurance: ["8M"],
			blazekick: ["8M"],
			bounce: ["8M"],
			bravebird: ["8M"],
			brickbreak: ["8M", "8L30"],
			bulkup: ["8M", "8L50"],
			closecombat: ["8M", "8L65"],
			coaching: ["8T"],
			counter: ["8L55"],
			detect: ["8L60"],
			drillpeck: ["8L35", "8S0", "8S1"],
			dualwingbeat: ["8T"],
			endure: ["8M"],
			facade: ["8M"],
			fly: ["8M"],
			focusenergy: ["8M", "8L1", "8S0", "8S1"],
			gigaimpact: ["8M"],
			hurricane: ["8M"],
			hyperbeam: ["8M"],
			lightscreen: ["8M", "8L10"],
			lowkick: ["8M"],
			lowsweep: ["8M"],
			megakick: ["8M"],
			payback: ["8M"],
			peck: ["8L1"],
			pluck: ["8L15"],
			protect: ["8M"],
			quickguard: ["8L40"],
			rest: ["8M"],
			retaliate: ["8M"],
			revenge: ["8M"],
			reversal: ["8M", "8L70", "8S0", "8S1"],
			rocksmash: ["8L5"],
			round: ["8M"],
			scaryface: ["8M"],
			screech: ["8M"],
			sleeptalk: ["8M"],
			snore: ["8M"],
			steelwing: ["8M"],
			stompingtantrum: ["8M"],
			substitute: ["8M"],
			superpower: ["8M"],
			swift: ["8M"],
			taunt: ["8M"],
			throatchop: ["8M"],
			thunderouskick: ["8L45", "8S0", "8S1"],
			uturn: ["8M"],
		},
		eventData: [
			{generation: 8, level: 70, moves: ["thunderouskick", "drillpeck", "reversal", "focusenergy"]},
			{generation: 8, level: 70, shiny: true, moves: ["thunderouskick", "drillpeck", "reversal", "focusenergy"], pokeball: "cherishball"},
		],
		eventOnly: true,
	},
	moltresgalar: {
		learnset: {
			afteryou: ["8L40"],
			agility: ["8M", "8L20"],
			airslash: ["8M", "8L35"],
			ancientpower: ["8L25"],
			assurance: ["8M"],
			bravebird: ["8M"],
			darkpulse: ["8M"],
			dualwingbeat: ["8T"],
			endure: ["8M", "8L60"],
			facade: ["8M"],
			fierywrath: ["8L45", "8S0", "8S1"],
			fly: ["8M"],
			foulplay: ["8M"],
			gigaimpact: ["8M"],
			gust: ["8L1"],
			hex: ["8M"],
			hurricane: ["8M", "8L55", "8S0", "8S1"],
			hyperbeam: ["8M"],
			hypervoice: ["8M"],
			imprison: ["8M"],
			lashout: ["8T"],
			leer: ["8L1"],
			memento: ["8L65"],
			nastyplot: ["8M", "8L50", "8S0", "8S1"],
			payback: ["8M", "8L5"],
			protect: ["8M"],
			rest: ["8M"],
			round: ["8M"],
			safeguard: ["8M", "8L10"],
			scaryface: ["8M"],
			shadowball: ["8M"],
			skyattack: ["8L70"],
			sleeptalk: ["8M"],
			snarl: ["8M"],
			snore: ["8M"],
			steelwing: ["8M"],
			substitute: ["8M"],
			suckerpunch: ["8L30", "8S0", "8S1"],
			swift: ["8M"],
			taunt: ["8M"],
			uturn: ["8M"],
			wingattack: ["8L15"],
		},
		eventData: [
			{generation: 8, level: 70, moves: ["fierywrath", "hurricane", "suckerpunch", "nastyplot"]},
			{generation: 8, level: 70, shiny: true, moves: ["fierywrath", "hurricane", "suckerpunch", "nastyplot"], pokeball: "cherishball"},
		],
		eventOnly: true,
	},
};
